import request from '@/utils/request'

export function getMembers(query) {
  return request({
    url: '/Member/getMembers',
    method: 'get',
    params: query,
  })
}

export function getTcMembers(data) {
  return request({
    url: '/Member/getTcMembers',
    method: 'post',
    data,
  })
}

export function getPendingReviewLeaderList(data) {
  return request({
    url: '/Member/getPendingReviewLeaderList',
    method: 'post',
    data,
  })
}

export function getTcRoleMembers(data) {
  return request({
    url: '/Member/getTcRoleMembers',
    method: 'post',
    data,
  })
}

export function saveData(data) {
  return request({
    url: '/Member/saveData',
    method: 'post',
    data,
  })
}

export function saveTcData(data) {
  return request({
    url: '/Member/saveTcData',
    method: 'post',
    data,
  })
}

export function saveTourLeaderInfo(data) {
  return request({
    url: '/Agency/saveTourLeaderInfo',
    method: 'post',
    data,
  })
}

export function getRoles() {
  return request({
    url: '/Member/getRoles',
    method: 'get',
  })
}

export function getTcRoles() {
  return request({
    url: '/Member/getTcRoles',
    method: 'get',
  })
}

export function saveRoles(data) {
  return request({
    url: '/Member/saveRoles',
    method: 'post',
    data,
  })
}

export function deleteMember(data) {
  return request({
    url: '/Member/deleteMember',
    method: 'post',
    data,
  })
}

export function getAgencyMembers(query) {
  return request({
    url: '/Member/getAgencyMembers',
    method: 'get',
    params: query,
  })
}

export function saveAgencyMemberData(data) {
  return request({
    url: '/Member/saveAgencyMemberData',
    method: 'post',
    data,
  })
}

export function saveUserProfileData(data) {
  return request({
    url: '/Member/saveUserProfileData',
    method: 'post',
    data,
  })
}

export function getAgencyRoles(query) {
  return request({
    url: '/Member/getAgencyRoles',
    method: 'get',
    params: query,
  })
}

export function getAgencyMemberFilterCountiesList(data) {
  return request({
    url: '/Member/getAgencyMemberFilterCountiesList',
    method: 'post',
    data,
  })
}

export function saveDemoAccounts(data) {
  return request({
    url: '/Member/saveDemoAccounts',
    method: 'post',
    data,
  })
}
